import type { ReactElement } from 'react';
import { EditorDialog } from '@/features/design-editor';
import { Button } from '@/shared/ui';

interface ResetConfirmDialogProps {
  readonly open: boolean;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
}

/** [처음으로] 확인 — 모든 면의 레이어를 지우기 전에 한 번 묻는다. 지운 뒤에도 취소(undo)로 되돌릴 수 있다. */
export const ResetConfirmDialog = ({
  open,
  onCancel,
  onConfirm,
}: ResetConfirmDialogProps): ReactElement => (
  <EditorDialog
    open={open}
    title="처음으로 되돌릴까요?"
    onClose={onCancel}
    footer={
      <>
        <Button type="button" variant="outline" onClick={onCancel}>
          그대로 두기
        </Button>
        <Button type="button" onClick={onConfirm}>
          모두 지우기
        </Button>
      </>
    }
  >
    <p className="leading-relaxed text-muted-foreground">
      모든 면의 이미지와 텍스트가 지워집니다. 지운 뒤에도 도구 막대의 [취소]로 되돌릴 수 있습니다.
    </p>
  </EditorDialog>
);
